module.exports = {"140222100":"玉泉镇","140222101":"谷前堡镇","140222102":"米薪关镇","140222103":"逯家湾镇","140222104":"新平堡镇","140222200":"卅里铺乡","140222202":"南河堡乡","140222204":"贾家屯乡","140222206":"赵家沟乡","140222208":"南高崖乡","140222209":"张西河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140222.json
// module id = 245
// module chunks = 0